<template>
  <v-dialog v-model="dialogApprove" persistent max-width="1000px" :retain-focus="false">
      <v-card>
        <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
        <div class="text-center">
          <h2 class="text-center txt-head">ดูข้อมูลการอนุมัติ</h2>
        </div>
        <v-card-title>
          <span class="txt-head pl-4" style="text-decoration: underline;">รายละเอียด</span>
        </v-card-title>
        <v-card-text style="margin-bottom: -25px;">
          <v-container>
              <v-layout class="row pl-4">
                <v-col cols="2">
                <p class="txt-font" style="margin-top: 15%; font-weight: bold">ประเภท</p>
              </v-col>
              <v-col cols="7">
                <p class="txt-font mt-5"> {{ "เพิ่มบุคคลเข้าทำงานในตำแหน่งงานใหม่" }}</p>
              </v-col>
            </v-layout>
            <v-layout class="row pl-4">
              <v-col cols="2">
                <p class="txt-font" style="margin-top: 0%; font-weight: bold">ข้อมูลพนักงาน</p>
              </v-col>
              <v-col cols="9">
                <div
              class="pa-0 container-card"
            >
            <!-- style="border: 0.5px solid #A4A4A4; border-radius: 4px;" -->
              <v-row class="pa-2">
                <!-- <v-col cols="2" sm="3" class="pt-0 pb-0 pr-0 container-img" style="border-right: 0.1vw solid #C0C0C0;"> -->
                <v-col cols="2" sm="3" class="pt-0 pb-0 pr-0 container-img">
                  <v-avatar
                    size="120"
                    rounded
                  >
                  <v-img
                    class="img-border"
                    cover
                    :lazy-src="require('@/assets/icons/no_user.png')"
                    :src="this.userImg ? this.userImg : require('@/assets/icons/no_user.png')"
                    aspect-ratio="2.7"
                  >
                  </v-img>
                  </v-avatar>
                </v-col>
                <v-col cols="10" sm="9">
                  <div>
                    <v-row class="ml-0 mr-0 mb-0 mt-2 container-space">
                      <div class="container-nameuser mr-5">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">คำนำหน้า : {{ employeeTitle }}</span>
                      </div>
                      <div class="container-nameuser mr-5">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">ชื่อ-นามสกุล : {{ employeeName }}</span>
                      </div>
                      <div class="container-nameuser mr-5">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">รหัสพนักงาน : {{ employeeId }}</span>
                      </div>
                      <div class="container-nameuser">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">สายงาน : {{ management }}</span>
                      </div>
                      <div class="container-nameuser">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">ส่วนงาน : {{ section }}</span>
                      </div>
                      <div class="container-nameuser mr-5">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">ฝ่ายงาน : {{ department }}</span>
                      </div>
                      <div class="container-nameuser">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">กลุ่มงาน : {{ groupwork }}</span>
                      </div>
                      <div class="container-nameuser">
                        <span class="label-nameen mr-1 ma-1 txt-font-large">ตำแหน่ง : {{ position }}</span>
                      </div>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
              </v-col>
            </v-layout>
            <v-layout class="row pl-4">
              <v-col cols="2">
                <p class="txt-font mt-5" style="font-weight: bold">สถานะ</p>
              </v-col>
              <v-col cols="10">
                <v-chip-group
                  class="mt-2"
                  active-class="primary--text"
                  column
                >
                <v-tooltip
                  bottom
                  v-for="el in statusShow"
                  :key="el.approverNo"
                >
                  <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    :color="['approve','acknowledge'].includes(el.approverStatus)? 'green lighten-2': ['reject'].includes(el.approverStatus)? 'red lighten-2':['cancel'].includes(el.approverStatus)? 'grey':'orange lighten-2'"
                  >
                    <p class="txt-font mt-5"> {{ el.approverStatusTH }} {{ el.approverStatus==='cancel'? '':`(ลำดับที่ ${el.approverNo} )` }}</p>
                  </v-chip>
                  </template>
                  <span class="label-table-action">{{ el.approverStatusTH }} {{ el.approverStatus==='cancel'? '':`(ลำดับที่ ${el.approverNo} )` }}</span>
                </v-tooltip>
                </v-chip-group>
              </v-col>
            </v-layout>
          <v-card
            class="mx-auto"
            max-width="900"
          >
            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="6" class="ml-4">
                  <span class="txt-font" style="font-weight: bold">หมายเลขคำร้อง :</span><span class="txt-font"> {{ reqEmployeeNo }} </span>
                </v-col>
              </v-row>
              <v-card-text>
                <div class="font-weight-bold ml-0 mb-2">
                  <span class="txt-font" style="font-weight: bold">ลำดับการทำงาน</span>
                </div>
                <v-timeline
                  align-top
                  dense
                >
                  <v-timeline-item
                    v-for="item in approver"
                    :key="item.approveDate"
                    :color="['approve','acknowledge'].includes(item.approverStatus)? 'green lighten-2': ['reject'].includes(item.approverStatus)? 'red lighten-2':'orange lighten-2'"
                    small
                  >
                  <v-row class="" style="margin-top: -10px;">
                    <v-col cols="10">
                      <div class="font-weight-normal">
                        <strong class="txt-font" style="font-weight: bold">ลำดับที่: {{item.approverNo}}  </strong><strong class="txt-font" style="font-weight: bold; text-decoration: underline;"> {{item.approverStatusTH}}</strong>  {{ item.approverDate? initDate(item.approverDate):'' }}
                        <strong class="txt-font" style="font-weight: bold; text-decoration: underline;">{{item.requestStatus}}</strong>
                        <strong class="txt-font"> {{ item.approveDate }}</strong>
                      </div>
                      <v-avatar rounded style="float: left;">
                      <v-img
                        :lazy-src="require('@/assets/icons/no_user.png')"
                        :src="item.approverImg"
                      ></v-img>
                    </v-avatar>
                      <div class="mt-1"><span class="txt-font ml-2">ชื่อ : {{ item.approverName }}</span></div>
                      <div class="mt-1"><span class="txt-font ml-2">ความเห็น : {{ item.approverComment || '-' }}</span></div>
                    </v-col>
                    <!-- <v-col cols="2">
                      <div class="container mt-1">
                        <img :src="require(`@/assets/icons/${['pending', 'acknowledge'].includes(item.approverStatus)?'wait':item.approverStatus}Asset.png`)" alt="Cinque Terre" width="500" height="150">
                      </div>
                    </v-col> -->
                  </v-row>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card-text>
          </v-card>
        </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3 create-orgchart-header-cancel-btn" color="primary" dark @click="closeDialogApprove">ปิด</v-btn>
        </v-card-actions>
      </v-card>
      <!-- <DialogTransferPermission/> -->
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import { hostImageUrlv3 } from '@/API/API'
// import swal from 'sweetalert'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
  },
  data () {
    return {
      mode: '',
      dialogApprove: false,
      id: '',
      reqEmployeeNo: '',
      requestType: '',
      employeeName: '',
      accountId: '',
      employeeId: '',
      employeeTitle: '',
      position: '',
      userImg: '',
      orgChartId: '',
      statusForApprove: '',
      status: [],
      management: '',
      section: '',
      department: '',
      agency: '',
      groupwork: '',
      approver: [],
      dataSource: [],
      filterData: []
    }
  },
  computed: {
    statusShow: function () {
      var filterStatus = this.status.filter(e => e.approverStatus === 'cancel')
      return filterStatus.length > 0 ? [filterStatus[0]] : this.status
    }
  },
  mounted () {
    EventBus.$on('openDialogManageApprove', this.getDetailRequest)
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
  },
  methods: {
    closeDialogApprove () {
      this.dialogApprove = false
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    async getDetailRequest (item) {
      // this.mode = mode
      // this.filterData = searchData
      const self = this
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/reqEmployee/getDetailReqEmployeeList`,
        method: 'POST',
        data: {
          requestId: item._id
        },
        headers: {
          authorization: this.$store.state.token
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // var temp = []
            response.data.result[0].id = response.data.result[0]._id
            Object.keys(response.data.result[0]).forEach(e => {
              if (e !== '_id') self[e] = response.data.result[0][e]
            })
            response.data.result[0].approver.map((el, index) => {
              // el.approverImg = this.api + '/' + el.approverImg
              if (el.approverImg === '') {
                el.approverImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                var splitImgApprove = el.approverImg.split('uploads/users_img/')[1]
                el.approverImg = `${hostImageUrlv3}/${splitImgApprove}/${el.emailOneId}`
              }
            })
            response.data.result.map((el, index) => {
              if (el.userImg === '') {
                this.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                var splitImgProfile = el.userImg.split('uploads/users_img/')[1]
                this.userImg = `${hostImageUrlv3}/${splitImgProfile}/${el.emailOneId}`
              }
            })
            // response.result.map((el, index) => {
            // })
          } else {
            self.dataSource = []
          }
        })
        .catch(function (thrown) {
        })
      this.dialogApprove = true
      this.loading = true
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

img {
  width: 100%;
  height: auto;
  margin-top: -10%;
  /* position: absolute; */
  z-index: auto;
}
</style>
